// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail_body {
  overflow-x: hidden;
}
.detail_body img {
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/detailpage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB","sourcesContent":[".detail_body {\n  overflow-x: hidden;\n}\n.detail_body img {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
